/* @flow */

const getSegment = (state) => state.app.braindates.joined;

import type { State } from 'src/shared/core/type/reduxTypes';

export const getJoinedBraindates = (state: State): number[] =>
  getSegment(state).joined;
